import barFillSound from '../assets/audio/bar-fill.ogg';
import outOfInkSound from '../assets/audio/out-of-ink.ogg';
import pathFollowSound from '../assets/audio/path-follow.ogg';
import pencilDrawingSound from '../assets/audio/pencildrawing.ogg';
import pickupSound from '../assets/audio/pickup.ogg';
import victorySound from '../assets/audio/victory.ogg';

export const TRACING_GAME_SOUND_KEYS = {
	barFill: 'tracing-bar-fill',
	outOfInk: 'tracing-out-of-ink',
	pathFollow: 'tracing-path-follow',
	pencilDrawing: 'tracing-pencil-drawing',
	pickup: 'tracing-pickup',
	victory: 'tracing-victory-sound',
} as const;

export const TRACING_GAME_SOUND_VOLUMES = {
	barFill: 0.6,
	outOfInk: 0.6,
	pathFollow: 0.2,
	pencilDrawing: 0.6,
	pickup: 0.5,
	victory: 0.6,
} as const;

export const TRACING_GAME_SOUNDS = [
	{ key: TRACING_GAME_SOUND_KEYS.outOfInk, url: outOfInkSound },
	{ key: TRACING_GAME_SOUND_KEYS.barFill, url: barFillSound },
	{ key: TRACING_GAME_SOUND_KEYS.pathFollow, url: pathFollowSound },
	{ key: TRACING_GAME_SOUND_KEYS.pencilDrawing, url: pencilDrawingSound },
	{ key: TRACING_GAME_SOUND_KEYS.pickup, url: pickupSound },
	{ key: TRACING_GAME_SOUND_KEYS.victory, url: victorySound },
] as const;
